import { Button, Text } from 'styles/AppStyles';
import { Container } from './Styles';
import { currentGameConfig } from 'utils/handleCurrentContentConfig';

const Banned = () => {
  const { redirector } = currentGameConfig;
  return (
    <Container>
      <Text>Seems like you are having problems logging into the store.</Text>
      <Text>Please contact support for help.</Text>
      <Button $isModal onClick={() => window.open(redirector)}>
        Back to the game
      </Button>
    </Container>
  );
};

export default Banned;
